const prefix = "app/ReportsV2/EngagementMeasurement"

export const GET_MEASURE_ENGAGEMENT_WATCHER = `${prefix}/GET_MEASURE_ENGAGEMENT_WATCHER`
export const GET_MEASURE_ENGAGEMENT_SUCCESS = `${prefix}/GET_MEASURE_ENGAGEMENT_SUCCESS`
export const GET_MEASURE_ENGAGEMENT_FAILED = `${prefix}/GET_MEASURE_ENGAGEMENT_FAILED`

export const GET_DIMENSIONS_DATA_WATCHER = `${prefix}/GET_DIMENSIONS_DATA_WATCHER`
export const GET_DIMENSIONS_DATA_SUCCESS = `${prefix}/GET_DIMENSIONS_DATA_SUCCESS`
export const GET_DIMENSIONS_DATA_FAILED = `${prefix}/GET_DIMENSIONS_DATA_FAILED`
